{
  "common": {
    "save": "Save",
    "saveChanges": "Save changes",
    "cancel": "Cancel",
    "close": "Close",
    "edit": "Edit",
    "delete": "Delete",
    "view": "View",
    "add": "Add",
    "confirm": "Confirm",
    "retry": "Retry",
    "yes": "Yes",
    "no": "No",
    "loadingPage": "Loading page",
    "comingSoonDescription": "This module is under construction and will be available soon.",
    "somethingWentWrong": "Something went wrong. Please try again.",
    "networkError": "Unable to reach the server. Check your connection and try again.",
    "requestCancelled": "Request cancelled.",
    "back": "Back"
  },
  "nav": {
    "dashboard": "Dashboard",
    "clients": "Clients",
    "reservations": "Reservations",
    "guests": "Guests",
    "restaurants": "Restaurants",
    "users": "Users",
    "logs": "Logs",
    "logsList": "Logs",
    "logsOccupancy": "Occupancy",
    "logsTopGuests": "Top Guests",
    "logsCancellations": "Cancellations",
    "settings": "Settings",
    "settingsRates": "Rates",
    "settingsChildCategories": "Child Categories",
    "settingsConfiguration": "Configuration",
    "settingsTemplates": "Templates",
    "settingsSmtp": "SMTP",
    "settingsRecaptcha": "Google reCAPTCHA"
  },
  "layout": {
    "openMenu": "Open navigation menu",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "switchToLightMode": "Switch to light mode",
    "switchToDarkMode": "Switch to dark mode",
    "notifications": "Notifications",
    "notificationsEmpty": "You're all caught up. New notifications will show up here.",
    "accountMenu": "Account menu",
    "changeLanguage": "Change language"
  },
  "account": {
    "profile": "Profile",
    "changePassword": "Change password",
    "logout": "Logout",
    "logoutAll": "Sign out of all devices",
    "signOutTitle": "Sign out",
    "signOutDescription": "Are you sure you want to sign out of your account?",
    "signOutConfirm": "Sign out",
    "signOutEverywhereTitle": "Sign out everywhere",
    "signOutEverywhereDescription": "This revokes every access token issued to your account, signing you out on all devices and browsers, including this one.",
    "signOutEverywhereConfirm": "Sign out everywhere"
  },
  "language": {
    "en": "English",
    "de": "German"
  },
  "auth": {
    "welcomeBackTitle": "Welcome back",
    "welcomeBackSubtitle": "Sign in to continue to your dashboard.",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "rememberMe": "Remember me",
    "forgotPasswordLink": "Forgot password?",
    "signIn": "Sign in",
    "loginFailed": "Login failed.",
    "forgotPasswordTitle": "Forgot password",
    "forgotPasswordDescription": "Enter the email associated with your account and we'll send you a link to reset your password.",
    "sendResetLink": "Send reset link",
    "requestFailed": "Request failed.",
    "checkYourEmailTitle": "Check your email",
    "checkYourEmailDescription": "If an account exists for that email, we've sent a link to reset your password.",
    "resetYourPasswordTitle": "Reset your password",
    "newPasswordLabel": "New password",
    "confirmNewPasswordLabel": "Confirm new password",
    "resetPasswordButton": "Reset password",
    "passwordResetTitle": "Password reset",
    "passwordResetDescription": "Your password has been updated. You can now sign in with your new password.",
    "invalidLinkTitle": "Invalid or expired link",
    "invalidLinkDescription": "This password reset link is missing or no longer valid. Request a new one from the forgot password page.",
    "backToLogin": "Back to login",
    "sessionExpired": "Your session has expired. Please sign in again.",
    "forbiddenAction": "You do not have permission to perform this action.",
    "verifyEmail": {
      "invalidTitle": "Invalid verification link",
      "invalidDescription": "This verification link is incomplete or malformed. Sign in and request a new one from your profile.",
      "verifying": "Verifying your email address…",
      "failedTitle": "Verification failed",
      "failedDefault": "This verification link is invalid or has expired.",
      "verifiedTitle": "Email verified",
      "verifiedDefault": "Your email address has been verified successfully.",
      "continueToSignIn": "Continue to sign in"
    },
    "passwordStrengthLabel": "Password strength: {{label}}",
    "passwordStrength": {
      "veryWeak": "Very weak",
      "weak": "Weak",
      "fair": "Fair",
      "good": "Good",
      "strong": "Strong"
    },
    "brandPanel": {
      "tagline": "Restaurant management, simplified.",
      "subtitle": "Reservations, tables, and guests — all in one place, built for busy restaurant teams.",
      "features": {
        "reservations": "Effortless reservation management",
        "tables": "Real-time table availability",
        "guests": "A complete view of every guest"
      },
      "footer": "© {{year}} JustTable. All rights reserved."
    }
  },
  "dashboard": {
    "welcome": "Welcome",
    "welcomeWithName": "Welcome, {{name}}",
    "subtitle": "Here's what's happening across your restaurants today.",
    "loadError": "Unable to load the dashboard summary. Please try again.",
    "stats": {
      "reservationsToday": "Reservations Today",
      "coversToday": "Covers Today",
      "occupancyNow": "Table Occupancy Now",
      "occupancySublabel": "{{occupied}} of {{total}} tables",
      "notConfirmed": "Not Confirmed",
      "restaurantsAndTeam": "Restaurants / Team",
      "restaurantsAndTeamSublabel": "Active restaurants / staff"
    },
    "statusBreakdown": {
      "title": "Today's Reservations by Status"
    },
    "upcoming": {
      "title": "Upcoming Reservations",
      "viewAll": "View all",
      "partySize": "{{count}} guest",
      "partySize_other": "{{count}} guests",
      "emptyTitle": "No upcoming reservations",
      "emptyDescription": "There are no more reservations scheduled for today."
    },
    "restaurants": {
      "title": "Restaurants Overview",
      "emptyTitle": "No restaurants yet",
      "reservationsToday": "{{count}} today",
      "occupancy": "{{occupied}}/{{total}} tables occupied ({{percent}}%)"
    }
  },
  "checkin": {
    "unknownRestaurant": "Restaurant",
    "table": {
      "tableLabel": "Table {{tableNumber}}"
    },
    "steps": {
      "contact": "Contact Details",
      "otp": "Verify Phone",
      "done": "Done"
    },
    "contact": {
      "title": "Welcome!",
      "subtitle": "Please share your contact details to check in at this table.",
      "editTitle": "Edit your details",
      "editSubtitle": "Update your mobile number below and we'll send a new verification code.",
      "editNote": "Your name, email and postal code are already saved for this table — only your mobile number can be changed here. Ask staff if the other details need correcting.",
      "titleLabel": "Title",
      "titleMr": "Mr",
      "titleMs": "Ms",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Mobile number",
      "phoneCountry": "Country",
      "phonePlaceholder": "e.g. 79 123 45 67",
      "zipCode": "ZIP / postal code",
      "email": "Email",
      "privacyConsent": "I accept the privacy policy.",
      "submit": "Continue",
      "editSubmit": "Update & resend code",
      "submitError": "Unable to check in right now. Please try again."
    },
    "otp": {
      "back": "Edit details",
      "title": "Verify your phone",
      "subtitle": "Enter the 6-digit code sent to {{phone}}.",
      "codeLabel": "Verification code",
      "devBypassHint": "Dev mode: no SMS gateway is wired up yet — use test code 123456.",
      "noCode": "Didn't receive a code?",
      "resend": "Resend code",
      "resending": "Sending…",
      "resendSuccess": "A new code has been sent.",
      "resendError": "Unable to resend the code. Please try again.",
      "submit": "Verify",
      "submitError": "That code didn't work. Please try again."
    },
    "success": {
      "title": "You're checked in",
      "description": "Thanks! Here's a summary of your check-in.",
      "confirmed": "Confirmed",
      "bookingNumber": "Booking No.",
      "guest": "Guest",
      "table": "Table",
      "restaurant": "Restaurant",
      "date": "Date",
      "time": "Time",
      "footerNote": "You're all set — no further action needed. Show this screen to staff if you need anything."
    },
    "unavailable": {
      "title": "This link isn't available",
      "invalidLink": "This check-in link is missing or invalid. Please scan the QR code on your table again.",
      "notFound": "We couldn't find this table. Please scan the QR code on your table again.",
      "loadError": "We couldn't load this table right now. Please try again in a moment."
    }
  },
  "reservations": {
    "pageTitle": "Reservations",
    "pageSubtitle": "Manage bookings across your restaurants.",
    "addReservation": "Add Reservation",
    "addDialogTitle": "Add Reservation",
    "editDialogTitle": "Edit Reservation",
    "viewDialogTitle": "Reservation",
    "createReservation": "Create Reservation",
    "saveError": "Unable to save this reservation.",
    "createSuccess": "Reservation created successfully.",
    "updateSuccess": "Reservation updated successfully.",
    "tableConflictDialog": {
      "title": "Table already booked",
      "confirm": "Book anyway",
      "cancel": "Choose different table"
    },
    "successDialog": {
      "titleCreated": "Reservation created successfully",
      "titleUpdated": "Reservation updated successfully",
      "addReservation": "Add Reservation"
    },
    "loadListError": "Unable to load reservations. Please try again.",
    "loadOneError": "Unable to load this reservation. It may have been cancelled.",
    "searchPlaceholder": "Search by guest name…",
    "clearSearch": "Clear search",
    "emptyTitle": "No Reservations Found",
    "emptyDescriptionSearch": "No reservations match your filters.",
    "emptyDescriptionDefault": "Reservations you add will show up here.",
    "unknownGuest": "Walk-in / Unknown guest",
    "cancelAction": "Cancel reservation",
    "cancelTitle": "Cancel reservation",
    "cancelDescription": "Cancel the reservation for \"{{name}}\"? This action cannot be undone.",
    "cancelConfirm": "Cancel reservation",
    "cancelSuccess": "Reservation cancelled successfully.",
    "cancelError": "Unable to cancel this reservation. Please try again.",
    "alreadyCanceled": "This reservation is already cancelled.",
    "cannotEditCanceled": "A cancelled reservation cannot be edited.",
    "occupancy": {
      "summary": "Occupancy: {{total}} guests ({{inhouse}} INHOUSE + {{external}} EXT)"
    },
    "table": {
      "srNo": "#",
      "dateTime": "Date & Time",
      "guest": "Guest",
      "table": "Table",
      "party": "Persons",
      "status": "Status",
      "actions": "Actions",
      "bookingNumber": "Booking #",
      "restaurant": "Restaurant",
      "guestInfoNotes": "Guest Info / Notes",
      "halfPortionAbbreviation": "HP",
      "noShow": "No Show",
      "groupBadge": "Grouped across {{count}} tables",
      "repeatBadge": "Repeating booking, day {{sequence}} of {{total}}"
    },
    "group": {
      "viewAll": "View All Group",
      "dialogTitle": "Group Reservations",
      "loadError": "Unable to load this group's reservations.",
      "emptyTitle": "No Group Reservations",
      "emptyDescription": "This group has no reservations on this date.",
      "primaryBooking": "Booking #{{number}} is the primary reservation for this group.",
      "primaryLabel": "Primary",
      "tableLabel": "Table {{number}}",
      "bookingNumber": "Booking #{{number}}",
      "editGroup": "Edit Whole Group"
    },
    "booking": {
      "viewSeries": "View Repeating Series",
      "dialogTitle": "Repeating Reservation",
      "loadError": "Unable to load this series' reservations.",
      "emptyTitle": "No Repeating Reservations",
      "emptyDescription": "This series has no reservations.",
      "totalOccurrences": "Total occurrences: {{count}}"
    },
    "filters": {
      "title": "Filters",
      "allRestaurants": "All restaurants",
      "startDate": "From date",
      "endDate": "To date",
      "hideArrived": "Hide arrived",
      "search": "Search",
      "reset": "Reset",
      "shift": {
        "label": "Shift",
        "all": "All shifts"
      },
      "status": {
        "label": "Status",
        "all": "All statuses"
      },
      "view": {
        "label": "View",
        "withTable": "With table",
        "withoutTable": "Without table",
        "withAndWithoutTable": "With and without table",
        "arrivingToday": "Arriving today",
        "cancelledOnly": "Cancelled only",
        "waitlistOnly": "Waitlist only",
        "qrCodeOnly": "QR code only",
        "arrivedOnly": "Arrived only",
        "zfGuestsOnly": "Bed & breakfast guests only",
        "allGuests": "All guests"
      }
    },
    "status": {
      "NotConfirmed": "Not Confirmed",
      "Confirmed": "Normal",
      "Placed": "Provisional",
      "Waiting": "Waiting",
      "Block": "Blocked",
      "Canceled": "Cancelled"
    },
    "form": {
      "sectionBooking": "Booking",
      "restaurant": "Restaurant",
      "tables": "Tables",
      "date": "Date",
      "time": "Time",
      "lengthOfStay": "Length of stay (min)",
      "repeatingDay": "Repeat for (days)",
      "repeatingDayHint": "Creates the same booking across this many consecutive days.",
      "repeatingDayUnavailableWarning": "This range includes closed or unavailable date(s): {{dates}}. Shorten the repeat range or choose a different start date.",
      "repeatingDayUnavailableError": "This repeat range includes a closed or unavailable date. Shorten it or choose a different start date.",
      "repeatingDayUseMax": "Use {{count}} day",
      "repeatingDayUseMax_other": "Use {{count}} days",
      "repeatingDayUnavailableForSingle": "Not available when editing a single reservation from a group — repeat the whole group booking instead.",
      "editWholeGroup": "Edit Whole Group",
      "editThisReservationOnly": "Edit This Reservation Only",
      "editingWholeGroupHint": "Changes here apply to every table in this group booking.",
      "editingSingleReservationHint": "Changes here apply to this reservation only — the rest of the group is unaffected.",
      "singleTableEditHint": "Only this table's reservation will be updated; other tables in the group are unaffected.",
      "sectionParty": "Persons",
      "adults": "Adults",
      "halfPortion": "Half portion",
      "children1": "Children (group 1)",
      "children2": "Children (group 2)",
      "children3": "Children (group 3)",
      "children4": "Children (group 4)",
      "sectionGuest": "Guest",
      "existingGuest": "Search existing guest",
      "existingGuestHint": "Selecting a guest fills in their details below and links this booking to their profile.",
      "guestSearchHint": "Type at least 3 characters to search.",
      "guestSearchEmpty": "No matching guests found.",
      "guestSearchInfo": {
        "title": "Instruction",
        "usedTitle": "Search field used",
        "usedBody": "Entering at least 3 letters will show possible search results. After selecting an existing guest, their details can be updated.",
        "notUsedTitle": "Search field not used",
        "notUsedBody": "In this case, a new guest will be created."
      },
      "prefix": "Title",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "mobile": "Mobile",
      "zipCode": "Zip code",
      "guestRemarks": "Guest remarks",
      "saveGuest": "Save these details to the guest profile",
      "status": "Status",
      "note": "Note",
      "noteLocal": "Internal note",
      "cancelReason": "Cancellation reason",
      "initials": "Initials",
      "dateClosedWarning": "The restaurant is closed on this date.",
      "dateSpecialHoursNotice": "This date has special hours.",
      "sectionNotes": "Notes",
      "lengthOfStayEntireShift": "Entire Shift",
      "lengthOfStayMinutes": "{{count}} Minute",
      "lengthOfStayMinutes_other": "{{count}} Minutes",
      "guestType": "Guest Type",
      "newsletter": "Subscribe to newsletter",
      "sendConfirmation": "Send confirmation SMS/email",
      "addressConfirmed": "Guest address confirmed",
      "guestTypeOptions": {
        "external": "External",
        "hotelGuest": "Hotel Guest",
        "plus": "PLUS",
        "holidayApartment": "Holiday Apartment"
      },
      "saveGuestInfo": {
        "title": "Instruction",
        "checkedTitle": "Checkbox Checked",
        "checkedBody": "If the guest is found using the search field or already exists in multiple reservations, the guest information will be updated everywhere.",
        "uncheckedTitle": "Checkbox Unchecked",
        "uncheckedBody": "The guest information will only be stored or updated for this reservation. The guest will not be searchable later."
      },
      "sectionTimeAndDuration": "Time & Duration",
      "lengthOfStayHint": "Leave at \"Entire Shift\" to use the shift's default table turnover time.",
      "bookingWindow": "Table held from {{start}} to {{end}}",
      "repeatDateRange": "Repeats daily from {{start}} through {{end}}",
      "calendarLegend": {
        "special": "Special hours",
        "closed": "Closed"
      }
    },
    "detail": {
      "date": "Date",
      "time": "Time",
      "table": "Table",
      "party": "Persons",
      "lengthOfStay": "Length of stay",
      "email": "Email",
      "phone": "Phone",
      "mobile": "Mobile",
      "zipCode": "Zip code",
      "note": "Note",
      "noteLocal": "Internal note",
      "comment": "Comment",
      "createdAt": "Created at",
      "updatedAt": "Updated at",
      "adultsCount": "{{count}} Adult",
      "adultsCount_other": "{{count}} Adults",
      "childrenCount": "{{count}} Child",
      "childrenCount_other": "{{count}} Children",
      "bookingNumber": "Booking number",
      "totalPersons": "Total persons",
      "newsletter": "Newsletter",
      "currentTable": "Current table"
    },
    "tablePicker": {
      "selectRestaurantFirst": "Select a restaurant to see its tables.",
      "selectDateTimeFirst": "Select a booking date and time to view live table availability.",
      "noTables": "This restaurant has no tables configured yet.",
      "noAvailableTables": "No tables are available for this date, time and party size. Try a different time or restaurant.",
      "hint": "Click a table to select it. Multiple tables can be selected for a shared party.",
      "occupantTooltip": "{{status}} — {{name}}, {{time}}, {{count}} guests",
      "capacityTooltip": "Seats {{capacity}}",
      "reservationsOnTable": "Reservations On Table #{{table}}",
      "noReservationsToday": "No reservations on this table today.",
      "overlapsSelectedSlot": "Overlaps selected slot",
      "status": {
        "free": "Available",
        "occupied": "Occupied",
        "occupiedArrived": "Arrived",
        "tooSmall": "Too small for this party",
        "tooLarge": "Too large for this party",
        "limited": "Booking limit reached",
        "inactive": "Unavailable"
      }
    },
    "timeSlotPicker": {
      "selectRestaurantFirst": "Select a restaurant to view its available time slots.",
      "selectDateFirst": "Select a booking date to view available time slots.",
      "loading": "Loading available times…",
      "noSlots": "No bookable times found for this date.",
      "occupancyTooltip": "{{percent}}% of tables already booked"
    },
    "walkIn": {
      "action": "Seat Walk-in",
      "title": "Seat a Walk-in Guest",
      "confirm": "Seat Guest",
      "success": "Reservation {{id}} created successfully.",
      "error": "Unable to seat this guest. Please try again.",
      "restaurantClosed": "The restaurant is currently closed!",
      "note": "Walk in",
      "confirmationTitle": "Reservation {{id}} was created!",
      "referenceLabel": "Reservation #{{id}}",
      "done": "Done"
    },
    "markArrived": {
      "action": "Mark as Arrived",
      "title": "Mark as Arrived",
      "description": "Mark the reservation for \"{{name}}\" as arrived?",
      "confirm": "Mark as Arrived",
      "success": "Reservation marked as arrived successfully.",
      "error": "Unable to mark this reservation as arrived. Please try again.",
      "unmarkAction": "Mark as Not Arrived",
      "unmarkTitle": "Mark as Not Arrived",
      "unmarkDescription": "Mark the reservation for \"{{name}}\" as not arrived?",
      "unmarkConfirm": "Mark as Not Arrived",
      "unmarkSuccess": "Reservation marked as not arrived successfully.",
      "unmarkError": "Unable to update this reservation's arrival status. Please try again.",
      "alreadyArrived": "This reservation is already marked as arrived.",
      "disabledStatus": "This reservation's arrival status cannot be changed.",
      "disabledNotToday": "Only today's reservations can have their arrival status changed.",
      "arrivedLabel": "Arrived",
      "arrivedHint": "Guest has arrived"
    },
    "bulk": {
      "selectAll": "Select all reservations on this page",
      "selectRow": "Select this reservation",
      "selectedCount": "{{count}} reservation selected",
      "selectedCount_other": "{{count}} reservations selected",
      "cancelSelected": "Cancel selected",
      "cancelTitle": "Cancel reservations",
      "cancelDescription": "Cancel {{count}} selected reservations? This action cannot be undone.",
      "cancelSuccess": "Reservations cancelled successfully.",
      "cancelError": "Unable to cancel these reservations. Please try again."
    },
    "quickReassign": {
      "action": "Reassign table",
      "title": "Reassign Table",
      "currentAssignment": "Currently on table {{table}}, {{date}} at {{time}}.",
      "groupedHint": "This table is part of a group booking. Reassigning it here only moves this table — the rest of the group stays as is.",
      "hint": "Pick a time and table(s) for this reservation. The current table is selected by default — keep it, change it, or select additional tables to split this booking across several tables.",
      "confirm": "Reassign",
      "success": "Table reassigned successfully.",
      "error": "Unable to reassign this table. Please try again."
    },
    "print": {
      "action": "Print",
      "allRestaurants": "All restaurants",
      "generatedAt": "Generated at {{datetime}}"
    },
    "calendarView": {
      "action": "Calendar View",
      "pageTitle": "Calendar View",
      "pageSubtitle": "Table occupancy by time for the selected restaurant and date.",
      "backToList": "Back to list",
      "restaurantLabel": "Restaurant",
      "dateLabel": "Date",
      "tableColumn": "Table",
      "emptyTablesTitle": "No tables configured",
      "emptyTablesDescription": "This restaurant has no active tables to display.",
      "emptyClosedTitle": "Restaurant closed",
      "emptyClosedDescription": "There are no bookable time slots on this date.",
      "legendArrived": "Arrived",
      "legendArrivedHint": "Guest has arrived",
      "legendNormalGuest": "Normal guest",
      "legendTemporaryGuest": "Temporary guest",
      "legendBlocked": "Blocked",
      "legendClosed": "Closed",
      "legendOverlap": "Overlap",
      "legendOverlapHint": "Two reservations were placed on this table at the same time",
      "closedTooltip": "Outside opening hours",
      "blockedTooltip": "A booking can't start here — it would run into a reservation already on this table",
      "partySizeCount": "{{count}} Guest",
      "partySizeCount_other": "{{count}} Guests",
      "state": {
        "available": "Available",
        "closed": "Closed",
        "blocked": "Blocked",
        "occupied": "Occupied"
      }
    }
  },
  "dailyNotes": {
    "title": "Notes",
    "empty": "No note for this date.",
    "manage": "Notes & Files",
    "placeholder": "Daily note",
    "save": "Save",
    "saveSuccess": "Note saved successfully.",
    "saveError": "Unable to save this note. Please try again.",
    "deleteSuccess": "File removed successfully.",
    "deleteError": "Unable to remove this file. Please try again.",
    "uploadSuccess": "File uploaded successfully.",
    "uploadError": "Unable to upload this file. Please try again.",
    "fileUpload": {
      "title": "File Upload",
      "instructions": "Please select the file you wish to upload and then press the upload button once.",
      "pdfOnly": "Only files in .pdf format are accepted.",
      "chooseFile": "Choose file",
      "upload": "Upload",
      "view": "View",
      "delete": "Delete",
      "empty": "No files uploaded.",
      "limitReached": "Maximum of {{max}} files reached for this date."
    }
  },
  "guests": {
    "pageTitle": "Guests",
    "pageSubtitle": "Manage the people on your guest list.",
    "addGuest": "Add Guest",
    "searchPlaceholder": "Search by guest name…",
    "clearSearch": "Clear search",
    "filters": {
      "allRestaurants": "All restaurants"
    },
    "table": {
      "srNo": "Sr. No.",
      "guestName": "Guest Name",
      "phoneEmail": "Phone / Email",
      "guestType": "Guest Type",
      "status": "Status",
      "createdDate": "Created Date",
      "actions": "Actions"
    },
    "emptyTitle": "No Guests Found",
    "emptyDescriptionSearch": "No guests match your search. Try a different name.",
    "emptyDescriptionDefault": "Guests you add will show up here.",
    "loadListError": "Unable to load guests. Please try again.",
    "loadOneError": "Unable to load this guest. It may have been deleted.",
    "addDialogTitle": "Add Guest",
    "editDialogTitle": "Edit Guest",
    "viewDialogTitle": "Guest Details",
    "createGuest": "Create guest",
    "saveError": "Unable to save guest.",
    "createSuccess": "Guest created successfully.",
    "updateSuccess": "Guest updated successfully.",
    "deleteTitle": "Delete guest",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Guest deleted successfully.",
    "deleteError": "Unable to delete guest. Please try again.",
    "form": {
      "prefix": "Prefix",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "mobile": "Mobile",
      "zipCode": "Zip code",
      "notes": "Notes",
      "newsletter": "Subscribed to newsletter"
    },
    "detail": {
      "phone": "Phone",
      "mobile": "Mobile",
      "email": "Email",
      "zipCode": "Zip code",
      "newsletter": "Newsletter",
      "subscribed": "Subscribed",
      "notSubscribed": "Not subscribed",
      "notes": "Notes",
      "createdAt": "Created At",
      "updatedAt": "Updated At"
    }
  },
  "logs": {
    "pageTitle": "Logs",
    "pageSubtitle": "Audit trail of reservation activity — created, modified and cancelled bookings.",
    "table": {
      "dateTime": "Date/Time",
      "guest": "Guest",
      "reservation": "Reservation",
      "modification": "Modification",
      "staff": "Staff",
      "initials": "Initials"
    },
    "emptyTitle": "No Logs Found",
    "emptyDescription": "Reservation activity will show up here.",
    "loadListError": "Unable to load logs. Please try again."
  },
  "reports": {
    "filters": {
      "restaurantLabel": "Restaurant",
      "yearLabel": "Year"
    },
    "occupancy": {
      "pageTitle": "Occupancy",
      "pageSubtitle": "Confirmed, tabled reservations per day for the selected restaurant and year.",
      "table": {
        "date": "Date",
        "reservationCount": "Reservations"
      },
      "emptyTitle": "No Occupancy Data",
      "emptyDescription": "No confirmed reservations found for this restaurant and year.",
      "loadError": "Unable to load the occupancy report. Please try again."
    },
    "topGuests": {
      "pageTitle": "Top Guests",
      "pageSubtitle": "Guests with 2 or more visits on different dates this year.",
      "table": {
        "guestName": "Guest",
        "visitCount": "Visits",
        "visitDates": "Visit Dates"
      },
      "emptyTitle": "No Top Guests",
      "emptyDescription": "No guest has visited twice or more this year yet.",
      "loadError": "Unable to load the top guests report. Please try again."
    },
    "cancellations": {
      "pageTitle": "Cancellations",
      "pageSubtitle": "Cancelled reservations grouped by month.",
      "table": {
        "month": "Month",
        "reservationCount": "Cancellations",
        "adults": "Adults",
        "children": "Children"
      },
      "emptyTitle": "No Cancellations",
      "emptyDescription": "No cancelled reservations found for this restaurant and year.",
      "loadError": "Unable to load the cancellations report. Please try again."
    }
  },
  "restaurants": {
    "pageTitle": "Restaurants",
    "pageSubtitle": "Manage the restaurants in your account.",
    "addRestaurant": "Add Restaurant",
    "searchPlaceholder": "Search by restaurant name…",
    "clearSearch": "Clear search",
    "emptyTitle": "No Restaurants Found",
    "emptyDescriptionSearch": "No restaurants match your search. Try a different name.",
    "emptyDescriptionDefault": "Restaurants you add will show up here.",
    "loadListError": "Unable to load restaurants. Please try again.",
    "loadOneError": "Unable to load this restaurant. It may have been deleted.",
    "addDialogTitle": "Add Restaurant",
    "editDialogTitle": "Edit Restaurant",
    "viewDialogTitle": "Restaurant Details",
    "createRestaurant": "Create restaurant",
    "saveError": "Unable to save restaurant.",
    "createSuccess": "Restaurant created successfully.",
    "updateSuccess": "Restaurant updated successfully.",
    "deleteTitle": "Delete restaurant",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Restaurant deleted successfully.",
    "deleteError": "Unable to delete restaurant. Please try again.",
    "hoursAction": "Opening hours",
    "tablesAction": "Tables",
    "form": {
      "sectionBasic": "Basic Information",
      "sectionCommunication": "Communication",
      "sectionReservation": "Reservation Settings",
      "sectionAppearance": "Appearance & Visibility",
      "restaurantName": "Restaurant name",
      "email": "Email",
      "phone": "Phone",
      "restaurantEmail": "Reservation email",
      "restaurantEmailHint": "Used as the reply-to address on reservation emails.",
      "signatureMail": "Email signature",
      "hintText": "Hint text",
      "linkMenu": "Menu link",
      "linkCancellation": "Cancellation link",
      "defaultAdults": "Standard number of adults",
      "tableLimit": "Table limit",
      "intervalTime": "Interval time",
      "freePeriod": "Free period (min)",
      "blockingTime": "Blocking time (min)",
      "reminder": "Reminder",
      "hpBlock": "Table blocking when selecting half board",
      "webReservation": "Web reservation",
      "colorCode": "Highlight color",
      "visibleToAll": "In the list \"All Restaurants\"",
      "colorOptions": {
        "none": "None",
        "green": "Green",
        "violet": "Violet",
        "blue": "Blue",
        "orange": "Orange"
      },
      "tableBlockOptions": {
        "none": "No",
        "wholeShift": "The whole shift"
      },
      "intervalOptions": {
        "min15": "15 minutes",
        "min30": "30 minutes"
      },
      "tableLimitOptions": {
        "none": "No limit",
        "n": "{{count}} tables"
      },
      "reminderOptions": {
        "none": "None",
        "dayBeforeAm": "The day before (AM)"
      },
      "webReservationOptions": {
        "notAvailable": "Not available",
        "off": "Off",
        "on": "On"
      }
    },
    "detail": {
      "email": "Email",
      "phone": "Phone",
      "restaurantEmail": "Reservation email",
      "signatureMail": "Email signature",
      "hintText": "Hint text",
      "linkMenu": "Menu link",
      "linkCancellation": "Cancellation link",
      "colorCode": "Highlight color",
      "defaultAdults": "Standard number of adults",
      "tableLimit": "Table limit",
      "intervalTime": "Interval time",
      "freePeriod": "Free period",
      "blockingTime": "Blocking time",
      "reminder": "Reminder",
      "hpBlock": "Table blocking when selecting half board",
      "webReservation": "Web reservation",
      "visible": "Visible to all",
      "hidden": "Hidden",
      "createdAt": "Created At",
      "updatedAt": "Updated At"
    },
    "status": {
      "Active": "Active",
      "Pending": "Pending",
      "Blocked": "Blocked",
      "Deleted": "Deleted"
    }
  },
  "restaurantHours": {
    "pageTitle": "Opening Hours",
    "pageSubtitle": "Manage opening, special, and closed hours for this restaurant.",
    "backToRestaurants": "Back to restaurants",
    "invalidRestaurant": "No restaurant selected.",
    "addOpen": "Add Opening Hours",
    "addSpecial": "Add Special Hours",
    "addClosed": "Add Closed Hours",
    "addOpenTitle": "Add Opening Hours",
    "addSpecialTitle": "Add Special Opening Hours",
    "addClosedTitle": "Add Closed Hours",
    "editTitle": "Edit Hours",
    "create": "Create",
    "saveError": "Unable to save these hours.",
    "createSuccess": "Hours created successfully.",
    "updateSuccess": "Hours updated successfully.",
    "deleteTitle": "Delete hours",
    "deleteDescription": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Hours deleted successfully.",
    "deleteError": "Unable to delete these hours. Please try again.",
    "loadListError": "Unable to load opening hours. Please try again.",
    "loadOneError": "Unable to load this entry. It may have been deleted.",
    "emptyTitle": "No Hours Configured",
    "emptyDescription": "Opening, special, and closed hours you add will show up here.",
    "table": {
      "type": "Type",
      "shiftName": "Shift Name",
      "stayDuration": "Stay Duration",
      "stayDurationMinutes": "{{count}} Minute",
      "stayDurationMinutes_other": "{{count}} Minutes",
      "daysAndTime": "Days & Time",
      "closedFor": "Closed For",
      "actions": "Actions"
    },
    "type": {
      "Open": "Open",
      "Special": "Special",
      "Closed": "Closed"
    },
    "weekdays": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "form": {
      "shiftName": "Shift name",
      "tables": "Tables",
      "allTables": "All tables",
      "tableGroup": "Group {{letter}}",
      "stayDuration": "Stay duration (min)",
      "tableBlocking": "Table blocking",
      "tableBlockOptions": {
        "none": "No",
        "wholeShift": "The whole shift"
      },
      "timeFrom": "Time from",
      "timeTo": "Time to",
      "daysOfWeek": "Days of week",
      "dateFrom": "Date from",
      "dateTo": "Date to",
      "colorOptions": {
        "none": "None",
        "bisque": "Bisque",
        "darkSeaGreen": "Dark Sea Green",
        "lavender": "Lavender",
        "paleGoldenRod": "Pale Golden Rod"
      },
      "closedFor": "Closed for",
      "closedForOptions": {
        "internalAndOnline": "Internal and Online",
        "internalOnly": "Internal Only",
        "onlineOnly": "Online Only"
      },
      "highlightColor": "Highlight color",
      "timeRangeHint": "Note: a time range of e.g. 18:00 to 22:00 means the first possible reservation time is 18:00, and the last possible reservation time is 22:00.",
      "dateRangeOptionalHint": "Optional — leave blank to apply from today for the next 10 years."
    },
    "validation": {
      "timeToAfterFrom": "End time must be after the start time.",
      "dateToAfterFrom": "End date must be on or after the start date.",
      "weekDaysRequired": "Select at least one day of the week."
    }
  },
  "restaurantTables": {
    "pageTitle": "Table Layout",
    "pageSubtitle": "Manage tables and the floor plan for this restaurant.",
    "backToRestaurants": "Back to restaurants",
    "invalidRestaurant": "No restaurant selected.",
    "addTable": "Add Table",
    "addTitle": "Add Table",
    "editTitle": "Edit Table",
    "create": "Create",
    "saveError": "Unable to save this table.",
    "createSuccess": "Table created successfully.",
    "updateSuccess": "Table updated successfully.",
    "deleteTitle": "Delete table",
    "deleteDescription": "Are you sure you want to delete table \"{{name}}\"? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Table deleted successfully.",
    "deleteError": "Unable to delete this table. Please try again.",
    "loadListError": "Unable to load tables. Please try again.",
    "loadOneError": "Unable to load this table. It may have been deleted.",
    "emptyTitle": "No Tables Configured",
    "emptyDescription": "Tables you add will show up here.",
    "table": {
      "srNo": "#",
      "tableNumber": "Table No.",
      "minMax": "Min / Max",
      "standard": "Standard",
      "shapeSize": "Shape & Size",
      "attributeGroup": "Group",
      "status": "Status",
      "actions": "Actions"
    },
    "shape": {
      "rectangleHorizontal": "Rectangle (Horizontal)",
      "rectangleVertical": "Rectangle (Vertical)",
      "round": "Round"
    },
    "size": {
      "small": "Small",
      "medium": "Medium",
      "big": "Big"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "sameAs": "Same As"
    },
    "form": {
      "tableNumber": "Table number",
      "minSpace": "Min seats",
      "maxSpace": "Max seats",
      "standardSpace": "Standard seats",
      "tableShape": "Table shape",
      "tableSize": "Table size",
      "xPos": "X position",
      "yPos": "Y position",
      "attributeGroup": "Group",
      "noAttributeGroup": "None",
      "tableGroup": "Group {{letter}}",
      "status": "Status",
      "sameAsTable": "Same as table"
    },
    "validation": {
      "maxGreaterThanMin": "Max seats must be greater than or equal to min seats.",
      "defaultBetweenMinMax": "Standard seats must be between min and max seats."
    },
    "qrCode": {
      "printAction": "Print QR Code",
      "printError": "Unable to generate the QR-code PDF. Please try again."
    },
    "map": {
      "uploadTitle": "Upload Table Map",
      "uploadAction": "Upload Table Map",
      "replaceAction": "Replace Table Map",
      "uploadHint": "Upload a JPEG image of your restaurant floor plan (max 2MB). You can then click anywhere on it to place a table.",
      "uploadInfo": "Please select the file you want to upload and then click the Upload button once.\nOnly files in .jpg format are allowed.\n\nThe table map must not contain any tables — only walls and stations, plus labels where needed.\nIt must be 690px wide.",
      "chooseFile": "Choose file",
      "fileRequired": "Please choose a JPEG image to upload.",
      "uploadSuccess": "Table map uploaded successfully.",
      "uploadError": "Unable to upload the table map. Please try again.",
      "emptyTitle": "No Table Map Uploaded",
      "emptyDescription": "Upload a floor plan image to place tables visually, or use the Add Table button below.",
      "clickHint": "Click anywhere on the floor plan to add a table at that position. Click an existing table to edit it, or drag it to reposition."
    }
  },
  "rates": {
    "pageTitle": "Rates",
    "pageSubtitle": "Manage the rate plans available to your restaurants.",
    "infoNote": {
      "line1": "Configure here the rates whose reservations should be imported from the PMS.",
      "line2": "Reservations whose rate designation contains \"HP\", \"VP\", or \"Pa\" are imported automatically and therefore don't necessarily need to be entered.",
      "line3": "Entering a short name is optional. If one is provided, it will be shown in the reservation list."
    },
    "addRate": "Add Rate",
    "searchPlaceholder": "Search by rate name…",
    "clearSearch": "Clear search",
    "table": {
      "srNo": "Sr. No.",
      "rateName": "Rate Name",
      "abbreviation": "Abbreviation",
      "createdDate": "Created Date",
      "actions": "Actions"
    },
    "emptyTitle": "No Rates Found",
    "emptyDescriptionSearch": "No rates match your search. Try a different name.",
    "emptyDescriptionDefault": "Rates you add will show up here.",
    "loadListError": "Unable to load rates. Please try again.",
    "loadOneError": "Unable to load this rate. It may have been deleted.",
    "addDialogTitle": "Add Rate",
    "editDialogTitle": "Edit Rate",
    "viewDialogTitle": "Rate Details",
    "createRate": "Create rate",
    "saveError": "Unable to save rate.",
    "createSuccess": "Rate created successfully.",
    "updateSuccess": "Rate updated successfully.",
    "deleteTitle": "Delete rate",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Rate deleted successfully.",
    "deleteError": "Unable to delete rate. Please try again.",
    "form": {
      "rateName": "Rate name",
      "abbreviation": "Abbreviation"
    },
    "detail": {
      "abbreviation": "Abbreviation",
      "createdAt": "Created At",
      "updatedAt": "Updated At"
    }
  },
  "childCategories": {
    "pageTitle": "Child Categories",
    "pageSubtitle": "Manage the child age-group categories available for this tenant's reservations.",
    "addChildCategory": "Add Child Category",
    "table": {
      "srNo": "Sr. No.",
      "nameEn": "Name (English)",
      "nameDe": "Name (German)",
      "createdDate": "Created Date",
      "actions": "Actions"
    },
    "emptyTitle": "No Child Categories Found",
    "emptyDescriptionSearch": "No child categories match your search. Try a different name.",
    "emptyDescriptionDefault": "Child categories you add will show up here.",
    "loadListError": "Unable to load child categories. Please try again.",
    "loadOneError": "Unable to load this child category. It may have been deleted.",
    "addDialogTitle": "Add Child Category",
    "editDialogTitle": "Edit Child Category",
    "createChildCategory": "Create child category",
    "saveError": "Unable to save child category.",
    "createSuccess": "Child category created successfully.",
    "updateSuccess": "Child category updated successfully.",
    "deleteTitle": "Delete child category",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Child category deleted successfully.",
    "deleteError": "Unable to delete child category. Please try again.",
    "form": {
      "nameEn": "Name (English)",
      "nameDe": "Name (German)"
    }
  },
  "configurations": {
    "pageTitle": "Configuration",
    "pageSubtitle": "Settings and feature options available to your account.",
    "noDescription": "No description provided.",
    "emptyTitle": "No Configurations Found",
    "emptyDescription": "There are no configuration options to show yet.",
    "loadListError": "Unable to load configurations. Please try again.",
    "customized": "Customized",
    "default": "Default",
    "viewDetails": "View details",
    "detail": {
      "description": "Description",
      "note": "Note",
      "value": "Configured value",
      "enable": "Enable",
      "disable": "Disable"
    }
  },
  "users": {
    "pageTitle": "Users",
    "pageSubtitle": "Manage staff accounts and their access roles.",
    "addUser": "Add User",
    "searchPlaceholder": "Search by name or email…",
    "clearSearch": "Clear search",
    "table": {
      "srNo": "Sr. No.",
      "userName": "Name",
      "email": "Email",
      "userType": "User Type",
      "status": "Status",
      "actions": "Actions"
    },
    "emptyTitle": "No Users Found",
    "emptyDescriptionSearch": "No users match your search. Try a different name.",
    "emptyDescriptionDefault": "Users you add will show up here.",
    "loadListError": "Unable to load users. Please try again.",
    "loadOneError": "Unable to load this user. It may have been deleted.",
    "addDialogTitle": "Add User",
    "editDialogTitle": "Edit User",
    "createUser": "Create user",
    "saveError": "Unable to save user.",
    "createSuccess": "User created successfully.",
    "updateSuccess": "User updated successfully.",
    "deleteTitle": "Delete user",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "User deleted successfully.",
    "deleteError": "Unable to delete user. Please try again.",
    "form": {
      "userType": "User Type",
      "selectRole": "Select role",
      "title": "Title",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phoneNumber": "Phone number",
      "password": "Password",
      "newPassword": "New password",
      "newPasswordHint": "Leave blank to keep the current password.",
      "confirmPassword": "Confirm password"
    }
  },
  "clients": {
    "pageTitle": "Clients",
    "pageSubtitle": "Manage client accounts and their configuration assignments.",
    "addClient": "Add Client",
    "searchPlaceholder": "Search by name or email…",
    "clearSearch": "Clear search",
    "manageConfiguration": "Manage configuration",
    "table": {
      "srNo": "Sr. No.",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "status": "Status",
      "actions": "Actions"
    },
    "emptyTitle": "No Clients Found",
    "emptyDescriptionSearch": "No clients match your search. Try a different name.",
    "emptyDescriptionDefault": "Clients you add will show up here.",
    "loadListError": "Unable to load clients. Please try again.",
    "loadOneError": "Unable to load this client. It may have been deleted.",
    "addDialogTitle": "Add Client",
    "editDialogTitle": "Edit Client",
    "createClient": "Create client",
    "saveError": "Unable to save client.",
    "createSuccess": "Client created successfully.",
    "updateSuccess": "Client updated successfully.",
    "deleteTitle": "Delete client",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Client deleted successfully.",
    "deleteError": "Unable to delete client. Please try again.",
    "form": {
      "name": "Client name",
      "email": "Email",
      "officeEmail": "Office email",
      "phone": "Phone number",
      "address": "Address",
      "smsSectionTitle": "SMS Credentials",
      "smsUsername": "SMS username",
      "smsPassword": "SMS password",
      "smsPasswordHint": "Leave blank to keep the current password.",
      "reservationDefaultsSectionTitle": "Reservation List Defaults",
      "defaultReservationView": "Default reservation view",
      "noOverride": "No override",
      "qrCodeReservationsVisible": "QR code reservations visible",
      "qrCodeReservationsVisibleHint": "Show reservations booked through the public QR self-service flow in the reservation list.",
      "showArrivedGuestsByDefault": "Show arrived guests by default",
      "showArrivedGuestsByDefaultHint": "Include already-arrived guests in the reservation list by default.",
      "showStaffInitials": "Show staff initials",
      "showStaffInitialsHint": "Display staff initials on reservations in the reservation list."
    },
    "configuration": {
      "pageTitle": "Client Configuration",
      "backToClients": "Back to Clients",
      "emptyTitle": "No configuration options available.",
      "loadError": "Unable to load this client's configuration. Please try again.",
      "saveSuccess": "Configuration assigned successfully.",
      "saveError": "Unable to assign configuration. Please try again.",
      "resetToDefault": "Reset to default",
      "resetSuccess": "Configuration reset to default successfully.",
      "resetError": "Unable to reset configuration. Please try again.",
      "sectionReservationList": "Reservation List",
      "sectionReservation": "Reservation",
      "sectionTableFloorPlan": "Table / Floor Plan",
      "sectionOther": "Other Configuration",
      "enabledLabel": "Enabled",
      "defaultSortingLabel": "Default sorting",
      "standardStatusLabel": "Standard reservation status",
      "allStatus": "All Status",
      "standardRestaurantLabel": "Standard restaurant",
      "allRestaurants": "All Restaurants",
      "defaultTimeLabel": "Default reservation time",
      "childrenCategoryLabel": "Children categories"
    }
  },
  "templates": {
    "pageTitle": "Template Management",
    "pageSubtitle": "Manage Email and SMS templates sent automatically for reservation events.",
    "addTemplate": "Add Template",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "allChannels": "All Channels",
    "allEvents": "All Events",
    "table": {
      "name": "Name",
      "event": "Event",
      "channel": "Channel",
      "subject": "Subject",
      "actions": "Actions"
    },
    "channels": {
      "email": "Email",
      "sms": "SMS"
    },
    "events": {
      "reservationCreated": "Reservation Created",
      "reservationUpdated": "Reservation Updated",
      "reservationTableReassigned": "Table Reassigned",
      "reservationCancelled": "Reservation Cancelled"
    },
    "emptyTitle": "No Templates Found",
    "emptyDescriptionSearch": "No templates match your search or filters. Try different criteria.",
    "emptyDescriptionDefault": "Templates you add will show up here.",
    "loadListError": "Unable to load templates. Please try again.",
    "loadOneError": "Unable to load this template. It may have been deleted.",
    "addDialogTitle": "Add Template",
    "editDialogTitle": "Edit Template",
    "createTemplate": "Create template",
    "saveError": "Unable to save template.",
    "createSuccess": "Template created successfully.",
    "updateSuccess": "Template updated successfully.",
    "deleteTitle": "Delete template",
    "deleteDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "deleteConfirm": "Delete",
    "deleteSuccess": "Template deleted successfully.",
    "deleteError": "Unable to delete template. Please try again.",
    "form": {
      "name": "Template name",
      "channel": "Channel",
      "event": "Reservation event",
      "subject": "Email subject",
      "insertPlaceholder": "Insert placeholder",
      "linkPrompt": "Link URL",
      "bodyHint": "Use the placeholder picker to insert dynamic reservation/guest values."
    },
    "preview": {
      "action": "Preview",
      "title": "Template Preview",
      "subject": "Subject",
      "body": "Body"
    }
  },
  "systemSettings": {
    "smtp": {
      "pageTitle": "SMTP Settings",
      "pageSubtitle": "Configure the outgoing mail server used to send system emails.",
      "loadError": "Unable to load SMTP settings. Please try again.",
      "isEnabled": "Enable custom SMTP",
      "host": "SMTP host",
      "port": "SMTP port",
      "encryption": "Encryption",
      "encryptionNone": "None",
      "username": "Username",
      "password": "Password",
      "passwordHint": "Leave blank to keep the currently saved password.",
      "fromAddress": "From address",
      "fromName": "From name",
      "testConnection": "Send test email",
      "testSuccess": "Test email sent successfully.",
      "testError": "Unable to send test email. Check your SMTP settings.",
      "updateSuccess": "SMTP settings updated successfully.",
      "updateError": "Unable to update SMTP settings."
    },
    "recaptcha": {
      "pageTitle": "Google reCAPTCHA Settings",
      "pageSubtitle": "Protect public forms from bots with Google reCAPTCHA.",
      "loadError": "Unable to load reCAPTCHA settings. Please try again.",
      "isEnabled": "Enable Google reCAPTCHA",
      "version": "Version",
      "versionV2": "v2 (Checkbox)",
      "versionV3": "v3 (Score-based)",
      "siteKey": "Site key",
      "secretKey": "Secret key",
      "secretKeyHint": "Leave blank to keep the currently saved secret key.",
      "scoreThreshold": "Minimum score",
      "scoreThresholdHint": "Submissions scoring below this value (0 to 1) will be rejected.",
      "updateSuccess": "reCAPTCHA settings updated successfully.",
      "updateError": "Unable to update reCAPTCHA settings."
    }
  },
  "reservationConfigurations": {
    "defaultSorting": {
      "dateTime": "Date & Time",
      "firstName": "First Name"
    }
  },
  "profile": {
    "pageTitle": "Profile",
    "pageSubtitle": "Manage your personal information and account settings.",
    "loadError": "Unable to load your profile. Please try again.",
    "security": "Security",
    "updateError": "Unable to update profile.",
    "updateSuccess": "Profile updated successfully.",
    "emailLabel": "Email",
    "firstName": "First name",
    "lastName": "Last name",
    "phoneNumber": "Phone number",
    "address": "Address",
    "city": "City",
    "dangerZoneTitle": "Danger zone",
    "dangerZoneDescription": "Deactivating your account signs you out of every device and disables sign-in until an administrator restores it.",
    "deactivateAccount": "Deactivate account",
    "deactivateTitle": "Deactivate account",
    "deactivateDescription": "This will immediately sign you out of all devices and disable your account. This action cannot be undone from here — are you sure you want to continue?",
    "deactivateConfirm": "Deactivate",
    "deactivateSuccess": "Your account has been deactivated.",
    "deactivateError": "Unable to deactivate account.",
    "resendEmailBanner": "Your email address is not verified yet.",
    "resendEmailButton": "Resend email",
    "resendEmailSuccess": "Verification email sent. Please check your inbox.",
    "resendEmailError": "Unable to resend verification email.",
    "changePasswordPageTitle": "Change password",
    "changePasswordPageSubtitle": "Choose a strong password you don't use anywhere else.",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmNewPassword": "Confirm new password",
    "updatePassword": "Update password",
    "changePasswordError": "Unable to change password.",
    "changePasswordSuccess": "Password changed successfully."
  },
  "errors": {
    "notFoundTitle": "Page not found",
    "notFoundDescription": "The page you are looking for doesn't exist or has been moved.",
    "backToHome": "Back to home",
    "unauthorizedTitle": "Access denied",
    "unauthorizedDescription": "You don't have permission to view this page.",
    "backToDashboard": "Back to dashboard",
    "serverErrorTitle": "Something went wrong",
    "serverErrorDescription": "An unexpected error occurred. Please try again."
  },
  "validation": {
    "required": "This field is required.",
    "invalidEmail": "Enter a valid email address.",
    "passwordTooShort": "Password must be at least 8 characters.",
    "passwordWeak": "Password must include an uppercase letter, a lowercase letter, a number, and a special character.",
    "passwordsMustMatch": "Passwords do not match.",
    "passwordSameAsCurrent": "New password must be different from your current password.",
    "reservationPartySizeRequired": "Add at least one adult or child, or choose Blocked.",
    "reservationTableRequired": "Select at least one table, or choose Waiting.",
    "checkinPhoneInvalid": "Enter a valid phone number.",
    "checkinPrivacyPolicyRequired": "You must accept the privacy policy to continue.",
    "checkinCodeInvalid": "Enter the 6-digit code."
  }
}
